import api from '../api';
import {
  IMyInstituteReqBody,
  IOrganization,
  IOrganizationReqBody,
  IOrganizationResponse,
} from '../../interface/organizationModel';
import { AxiosResponse } from 'axios';
import { OrganizationPreferenceRequest } from '../../interface/organizationPreference.interface';

export const getOrganizationPreferences = async () => {
  const response = await api.get('/organization/preference');
  return response.data;
};

export const updateOrganizationPreferences = async (preferences: OrganizationPreferenceRequest) => {
  const response = await api.put('/organization/preference', preferences);
  return response.data;
};

export const fetchMyOrganization = async (): Promise<AxiosResponse<IOrganizationResponse>> => {
  const res: AxiosResponse<IOrganizationResponse> = await api.get('/me/organization');
  return res;
};

export const updateMyInstitute = async (body: IMyInstituteReqBody, id: string) => {
  const res = await api.put(`/organization/${id}`, body);
  return res;
};

export const fetchTeacherStudentCountsService = async () => {
  const response = await api.get(`/organization/student/teacher`);
  return response.data;
};

export const createOrganizationService = async (body: IOrganizationReqBody) => {
  const response = await api.post(`/organization/create`, body);
  return response.data;
};

export const updateOrganizationService = async (id: string, body: IOrganization) => {
  const response = await api.put(`/organization/update/${encodeURIComponent(id)}`, body);
  return response.data;
};

export const organizationService = {
  fetchMyOrganization,
  updateMyInstitute,
};
